import { render, staticRenderFns } from "./Anasayfa.vue?vue&type=template&id=54ea2cc2&"
import script from "./Anasayfa.vue?vue&type=script&lang=js&"
export * from "./Anasayfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports